/**
 * @fileoverview Frontend environment variable validation using Zod schemas.
 * Provides runtime validation and type inference for Vite environment variables.
 */

import { z } from 'zod';

const envSchema = z.object({
  /** Optional API base URL override. Defaults to inferred URL based on hostname. */
  VITE_API_BASE_URL: z.string().url().optional(),
});

export type Env = z.infer<typeof envSchema>;

export const env: Env = envSchema.parse(import.meta.env);
